import _ from 'lodash';

const root = (state) => _.get(state, 'CommonState.caseTypes');

export const getCaseTypes = (state) => _.get(root(state), 'data', []);

export const getCaseTypesLoading = (state) =>
  _.get(root(state), 'fetching', false);

export const getCaseTypesError = (state) => _.get(root(state), 'fetchError');



// WEBPACK FOOTER //
// ./src/state/caseTypes/selectors.js